<template>
  <div v-if="!loaded" class="text-center">Chargement ...</div>
  <div v-else-if="!found" class="text-center">Document non trouvé</div>
  <div v-else>
    <div class="logo-wrapper mx-auto text-center text-red-500">
      <img src="/img/docs/logo-fils.png" alt="" />
      <p class="text-xs block pt-1">Réalisation de vos Rêves en Granit, Marbre, Pierre Bleue et autre</p>
    </div>

    <table cellpadding="0" cellspacing="0" class="text-sm">
      <tr class="top">
        <td colspan="5">
          <table>
            <tr>
              <td>
                <span class="font-bold">
                  {{ type }} <span v-if="!hasMockData">{{ prefix }}-{{ doc.doc_number }}</span>
                </span>
                <span class="block">{{ dateCreation }}</span>
              </td>

              <td>
                <span v-if="!isCreditNote" class="block font-bold">Date d'échéance:</span>
                <span v-if="!isCreditNote" class="inline-block">{{ dateEnding }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="text-sm">
        <td colspan="5">
          <table>
            <tr>
              <td>
                BE 0892.637.847<br />
                {{ 'Avenue de la Mutualité, 30'.toUpperCase() }}<br />
                {{ '7100 Haine-St-Paul, Belgique'.toUpperCase() }}<br />
                <span class="block pt-1">
                  <span class="block">Mail: <a href="" class="text-sm">marbrerie.ferraro@hotmail.com</a></span>
                  <span class="block">Tel: <a href="" class="text-sm">+32 496 44 09 29</a></span>
                </span>
              </td>

              <td>
                {{ client.name }}<br />
                <span v-if="client.vat" class="block">{{ client.vat }}</span>
                {{ joinIfNotEmpty([client.street, client.housenumber]).toUpperCase() }}<br />
                {{ joinIfNotEmpty([joinIfNotEmpty([client.zip, client.city]), client.country], ', ').toUpperCase() }}
                <span class="block pt-1" v-if="client.email || client.phone">
                  <span v-if="client.email" class="block">
                    Mail: <a href="" class="text-sm">{{ client.email }}</a>
                  </span>
                  <span v-if="client.phone" class="block">
                    Tel: <a href="" class="text-sm">{{ client.phone }}</a>
                  </span>
                </span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <div class="table-wrapper price-list no-border mt-2">
      <table cellpadding="0" cellspacing="0" :ref="el => (tableRef = el)">
        <colgroup>
          <col width="100%" />
          <col />
          <col />
          <col />
          <col width="40px;" />
          <col />
        </colgroup>
        <thead>
          <tr class="heading bg-gray-300">
            <td>Description</td>

            <td>Prix Unitée</td>

            <td>Q.</td>

            <td>Prix HTVA</td>

            <td>% TVA</td>

            <td>P.Tot TVAC</td>
          </tr>
        </thead>
        <tbody>
          <tr class="item border-b-0" v-for="(p, index) in products" :key="JSON.stringify(p) + index">
            <td>
              <div class="w-full flex">
                <span class="flex-1 text-left content-center items-center">
                  <span v-if="!isCreditNote" class="font-bold inline-block bg-indigo-100 rounded p-1 mr-1 -ml-1">
                    Code: {{ trim(p.code) }}
                  </span>
                  <span v-if="trim(p.description)">{{ trim(p.description) }}</span>
                  <span v-else-if="isCreditNote">Remboursement</span>
                </span>
                <span
                  v-if="!isCreditNote && (p.length > 0 || p.width > 0)"
                  class="font-bold rounded p-1 ml-auto text-xs -mr-2"
                >
                  <span v-if="p.length > 0">{{ p.length }} M</span>
                  <span v-if="p.length > 0 && p.width > 0"> x </span>
                  <span v-if="p.width > 0">{{ p.width }} M</span>
                </span>
              </div>
            </td>

            <td>{{ pricePrefix(p) }} &euro;&nbsp;{{ priceMapper(productPriceHTVA(p)) }}</td>

            <td>{{ p.quantity }}</td>

            <td>{{ pricePrefix(p) }} &euro;&nbsp;{{ priceMapper(productTotalPriceHTVA(p)) }}</td>

            <td>{{ p.vat }}%</td>

            <td>{{ pricePrefix(p) }} &euro;&nbsp;{{ priceMapper(productTotalPriceTVAC(p)) }}</td>
          </tr>
          <tr v-if="fillerRowHeight" class="item border-b-0" :style="`height: ${fillerRowHeight}`">
            <td style="vertical-align: top"></td>
            <td style="vertical-align: top"></td>
            <td style="vertical-align: top"></td>
            <td style="vertical-align: top"></td>
            <td style="vertical-align: top"></td>
            <td style="vertical-align: top"></td>
          </tr>
          <tr class="bg-gray-50 whitespace-nowrap">
            <td style="border-left: none; border-bottom: none; border-top: none; background: white" colspan="4"></td>
            <td class="font-normal text-xs py-1" style="text-align: right; padding: 6px 10px" colspan="2">
              <span class="w-20 inline-block text-left">Total HTVA: </span>&euro;&nbsp;{{
                priceMapper(totalPriceHTVA, true)
              }}
            </td>
          </tr>
          <tr class="bg-gray-50 whitespace-nowrap">
            <td style="border-left: none; border-bottom: none; border-top: none; background: white" colspan="4"></td>
            <td class="font-normal text-xs py-1" style="text-align: right; padding: 6px 10px" colspan="2">
              <span class="w-20 inline-block text-left">Total TVA: </span>&euro;&nbsp;{{ priceMapper(totalTVA, true) }}
            </td>
          </tr>
          <tr class="bg-white whitespace-nowrap">
            <td style="border-left: none; border-bottom: none; border-top: none; background: white" colspan="4"></td>
            <td class="font-bold" style="text-align: right; padding: 8px 10px" colspan="2">
              <span class="w-20 inline-block text-left">Total TVAC: </span>&euro;&nbsp;{{
                priceMapper(totalPriceTVAC, true)
              }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="w-full text-right text-sm pr-1 border-r-2 border-white" v-if="!hasMockData && apiType === 'invoices'">
        <p v-if="doc.amount_open > 0" class="mt-2 block text-red-500">
          <span class="font-bold">Montant restant</span>: &euro; {{ priceMapper(doc.amount_open) }}
        </p>
        <p v-else class="mt-2 block text-green-500">
          <span class="font-bold">Facture payée</span>
        </p>
      </div>
    </div>

    <div v-if="doc.description" class="float-left -mt-12 text-xs pl-2 block" style="max-width: 70%">
      <p>{{ trim(doc.description) }}</p>
    </div>

    <table class="w-full mt-4" cellpadding="0" cellspacing="0" v-if="!isCreditNote">
      <tr>
        <td colspan="5">
          <table class="text-xs">
            <tr>
              <td>
                <div v-if="!hasMockData && apiType === 'invoices' && payments?.length">
                  <TablePayments :payments="payments" @removed="paymentRemoved" />
                  <div class="w-full text-left text-xs pr-1" v-if="!hasMockData && apiType === 'invoices'">
                    <p v-if="doc.amount_open > 0" class="mt-2 block text-red-500">
                      <span class="font-bold">Montant restant</span>: &euro; {{ priceMapper(doc.amount_open) }}
                    </p>
                    <p v-else class="mt-2 block text-green-500">
                      <span class="font-bold">Facture payée</span>
                    </p>
                  </div>
                </div>
              </td>

              <td>
                <ul class="text-xl whitespace-nowrap">
                  <li><span class="font-bold">BANQUE</span>: CBC</li>
                  <li><span class="font-bold">IBAN</span>: BE77 7320 4335 8142</li>
                  <li><span class="font-bold">BIC</span>: CREGBEBB</li>
                  <li><span class="font-bold">Communication</span>: {{ prefix }}-{{ doc.doc_number }}</li>
                </ul>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div class="print-hidden" v-if="pictures.length">
      <button class="bg-blue-200 px-4 py-2 rounded" @click="showPictures = !showPictures">
        {{ showPictures ? 'Ne pas montrer les annexes' : 'Montrer les annexes' }}
      </button>
    </div>
    <template v-if="showPictures">
      <div v-for="(url, index) in pictures" :key="`${url}${index}`">
        <div class="bg-gray-100 -mx-8 py-2 my-8 print-hidden"></div>
        <div class="page-break mb-8">
          <h2 class="text-lg font-bold text-black">Annexe #{{ index + 1 }}</h2>
          <img class="w-full h-auto px-8 mx-auto mt-8" style="max-width: 96%" :src="url" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import TablePayments from '@/components/Table/Payments'
import useApi from '@/hooks/useApi'
// import MONTHS from '@/constants/MONTHS'
import { useRoute } from 'vue-router'
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

export default {
  props: {
    type: {
      type: String,
      required: true,
      default: 'Facture',
    },
    apiType: {
      type: String,
      required: true,
    },
    doc_number: {
      type: String,
    },
    mockDocument: Object,
    mockClient: Object,
    mockProducts: Array,
    mockPayments: Array,
  },
  components: {
    TablePayments,
  },
  setup(props) {
    const route = useRoute()
    const api = useApi()

    const onKeydown = e => {
      if ((e.ctrlKey || e.metaKey) && (e.key == 'p' || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80)) {
        alert('Utiliser le button print svp.')
        e.cancelBubble = true
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    }
    onMounted(() => {
      window.document.addEventListener('keydown', onKeydown)
    })
    onBeforeUnmount(() => {
      window.document.removeEventListener('keydown', onKeydown)
    })

    const hasMockData = props.mockDocument || props.mockClient || props.mockProducts || props.mockPayments
    const doc_number = computed(() => route.params.doc_number || props.doc_number || props.mockDocument?.doc_number)
    const client = ref(props.mockClient || {})
    const doc = ref(props.mockDocument || {})
    const products = ref(props.mockProducts || [])
    const payments = ref(props.mockPayments || [])
    const found = ref(!!hasMockData)
    const loaded = ref(!!hasMockData)

    const pictures = ref([])
    const showPictures = ref(props.apiType !== 'invoices')

    const joinIfNotEmpty = (arr, joinDilimeter = ' ') => arr.filter(el => !!el).join(joinDilimeter)
    const isCreditNote = computed(() => doc.value.type === 'CREDIT_NOTE' || props.apiType === 'credit-notes')

    const priceMapper = (price, allowNegative = false) => {
      let n = Number(price) * (isCreditNote.value ? -1 : 1)
      if (!allowNegative) n = Math.abs(n)
      return n.toFixed(2)
    }

    const productPriceHTVA = p => {
      if (p.price_type === 'PER_SQUARE_METER') {
        return p.price * (p.width / 1) * (p.length / 1)
      }
      if (p.price_type === 'PER_METER') {
        return p.price * (p.length / 1)
      }
      return p.price
    }

    const pricePrefix = p => (p.product_id === 0 && p.price <= 0 ? '-' : '')

    const productTotalPriceHTVA = p => productPriceHTVA(p) * p.quantity
    const productTotalPriceTVAC = p => {
      const n = productTotalPriceHTVA(p) * (1 + p.vat / 100)
      if (p.product_id === 0) return Math.round(n)
      return n
    }

    const totalPriceHTVA = computed(() =>
      products.value.reduce((total, next) => total + productTotalPriceHTVA(next), 0),
    )
    const totalPriceTVAC = computed(() =>
      products.value.reduce((total, next) => total + productTotalPriceTVAC(next), 0),
    )

    const totalTVA = computed(() => totalPriceTVAC.value - totalPriceHTVA.value)
    const prefixes = {
      INVOICE: 'FA',
      QUOTE: 'DV',
      CREDIT_NOTE: 'NC',
    }
    const prefix = computed(() => prefixes[doc.value.type])
    const dateCreation = computed(() => {
      const d = new Date(doc.value.date)
      return [d.getDate(), d.getMonth() + 1, d.getFullYear()].map(n => n.toString().padStart(2, '0')).join('/')
      // return [d.getDate(), MONTHS[d.getMonth()], d.getFullYear()].join(' ')
    })
    const dateEnding = computed(() => {
      const d = new Date(doc.value.date)
      d.setTime(d.getTime() + 1209600000)
      return [d.getDate(), d.getMonth() + 1, d.getFullYear()].map(n => n.toString().padStart(2, '0')).join('/')
      // return [d.getDate(), MONTHS[d.getMonth()], d.getFullYear()].join(' ')
    })

    if (route.params.doc_number && !hasMockData) {
      api[props.apiType]
        .get({ doc_number: doc_number.value })
        .then(res => {
          client.value = res?.data?.client || {}
          doc.value = res?.data?.doc
          products.value = res?.data?.products || []
          payments.value = res?.data?.payments || []
          found.value = true
          api.files
            .list({
              doc_number: (doc.value.type === 'INVOICE' && doc.value.doc_number_linked) || doc.value.doc_number,
              type: doc.value.type === 'INVOICE' && doc.value.doc_number_linked ? 'QUOTE' : doc.value.type,
            })
            .then(({ data }) => {
              pictures.value = data?.list || {}
            })
          return res
        })
        .finally(() => {
          loaded.value = true
        })
    }

    const tableRef = ref(null)
    // const printing = inject('printing')
    const fillerRowHeight = computed(() => {
      if (!tableRef.value) return 0
      const minimum = 800
      if (tableRef.value.clientHeight < minimum) {
        return `calc(${minimum}px - ${Math.round(tableRef.value.clientHeight)}px)`
      }
      return 0
    })

    return {
      trim(str) {
        return String(str || '').trim()
      },
      paymentRemoved(payment) {
        const found = payments.value.find(el => el.id === payment.id)
        if (found) {
          payments.value = payments.value.filter(el => el.id !== payment.id)
          doc.value.amount_open = Number(doc.value.amount_open) + Number(payment.amount)
        }
      },
      pricePrefix,
      tableRef,
      fillerRowHeight,
      dateCreation,
      dateEnding,
      prefix,
      client,
      doc,
      products,
      payments,
      hasMockData,
      found,
      loaded,
      pictures,
      showPictures,
      isCreditNote,
      joinIfNotEmpty,
      productPriceHTVA,
      productTotalPriceHTVA,
      productTotalPriceTVAC,
      priceMapper,
      totalPriceHTVA,
      totalPriceTVAC,
      totalTVA,
    }
  },
}
</script>

<style scoped lang="scss">
.logo-wrapper {
  max-width: 600px;
  margin-bottom: -16px;

  @media print {
    max-width: 60%;
  }
}
</style>
